import moment from 'moment';
import { useCallback, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { API_SERVER } from "../../Utils";
import { post } from "../../apiservices/service";
import { useAuth } from "../../context/auth";
import { Token, currentMonth, currentYear } from "../Common/Common";
import { Table } from '../commoncomponents/Table';

moment.locale("en-GB");
const localizer = momentLocalizer(moment)

const EmployeeMaster = () => {
    // Token data 
    const TokenData = Token();
    const { user, sessionExpired } = useAuth();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)
    const [eventsData, setEventsData] = useState();
    const [attendanceData, setAttendanceData] = useState([])
    const [tableData, setTableData] = useState({});



    const [getCurrentCalender, setGetCurrentCalender] = useState({
        Month: currentMonth(new Date(), 'numeric'),
        Year: currentYear(new Date()),
    })

    const [showAttendance, setShowAttendance] = useState({})

    //handle Attendance Marked
    const MarkAttendance = () => {
        post(`${API_SERVER}api/EmpDashboard/MarkAttendance`, { ...TokenData, }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    swal({
                        title: `${res.message}`,
                        icon: "error",
                    });
                } else if (res.status === "EXPIRED") {
                    sessionExpired();
                } else {
                    swal({
                        title: `${res.message}`,
                        icon: "success",
                    });
                    GetInTimeOutTime();
                    GetAttendanceDetailsData();
                }
            }
        });
    }

    //handle Get Attendance Details Data
    const GetInTimeOutTime = () => {
        post(`${API_SERVER}api/EmpDashboard/ShowInTimeOutTime`, { ...TokenData, }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setShowAttendance({})
                } else if (res.status === "EXPIRED") {
                    sessionExpired();
                } else {
                    setShowAttendance({...res.data})
                }
            }
        });
    }

    //handle Get Attendance Details Data 
    const GetAttendanceDetailsData = () => {
        post(`${API_SERVER}api/EmpDashboard/GetAttendanceDetails`, { ...TokenData, ...getCurrentCalender }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setAttendanceData({ ...res })
                } else if (res.status === "EXPIRED") {
                    sessionExpired();
                    setLoading(false);
                } else {
                    setLoading(false)
                    setAttendanceData({ ...res })
                }
            }
        });
    }

    //handle Get Leave Register Table Data 
    const GetLeaveRegisterTableData = () => {
        post(`${API_SERVER}api/Leave/ShowLeaveRegister`, { ...TokenData, Employee: `${user.empCode} : ${user.employeeName}` }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setTableData({ ...res })
                } else if (res.Status === "EXPIRED") {
                    sessionExpired()
                    setLoading(false)
                } else {
                    setLoading(false)
                    setTableData({ ...res })
                }
            }
        });
    }

    // set calender month year
    const handleNavigate = (date) => {
        setGetCurrentCalender({ ...getCurrentCalender, Year: currentYear(date), Month: currentMonth(date, 'numeric') })
    }
    function EventWrapper(props) {
        return <div {...props} style={{ backgroundColor: "yellow" }} />;
    }
    function DateCellWrapper(props) {
        return <div {...props} style={{ backgroundColor: "orange" }} />;
    }
    function DayWrapper(props) {
        return <div {...props} style={{ backgroundColor: "red", color: "white", padding: '20px' }} />;
    }

    const dayPropGetter = useCallback(
        (date) => ({
            ...(moment(date).day() === 0 && {
                className: `sunday`,
            }),
            ...(moment(date).day() === 0 && {
                style: {
                },
            }),
            ...(moment(date).day() === 6 && {
                style: {
                },
            }),
        }),
        []
    )

    //Set Event onCalender
    const getEvents = () => {
        const EventData = attendanceData?.data?.attendanceDetails?.map((ele) => {
            return {
                title: <span>{ele.attendance === (null || "") ? ele.holiday !== (null && "") ? < span className='text-danger fw-bold'>{ele.holiday}</span> : ele.leaveDay !== (null && "") ? <span className='text-danger fw-bold'>{ele.leaveDay}</span> : "" : < span className='text-success fw-bold'>{ele.attendance}</span>} < br />

                    In :  <span className='text-primary'>{ele.inTime}</span><br /> Out :  <span className='text-primary'>{ele.outTime}</span>
                </span>,
                start: new Date(ele.date),
                end: new Date(ele.date),
                resource: ele?.dayTitle ? ele.dayTitle : ""
            }
        })
        return EventData
    }

    // ToolTip Content
    const tooltipAccessor = (event) => {
        return event.resource
    }

    useEffect(() => {
        GetAttendanceDetailsData()
        GetLeaveRegisterTableData()
    }, [getCurrentCalender])

    useEffect(() => {
        GetInTimeOutTime();
    }, [])

    return (
        <>
            <div className='main-card card border-0 p-2 px-4'>
                <div className='row p-3 pt-2' style={{ display: 'none' }}>
                    <div className='p-0 px-2  border container rounded d-flex gap-2 align-items-center ' style={{ background: '#95d295b0' }}>
                        <span className='text-success'> Mark Your Attandance</span> < button className='btn btn-sm btn-primary my-2 mx-0 p-1 ' style={{ minWidth: '2.5rem' }} onClick={MarkAttendance}> <i className={`fa ${!user.isAttendenceMarked ? 'fa-sign-in' : 'fa-sign-out'} `}></i> {!user.isAttendenceMarked ? " In" : " Out"} </button>
                    </div>
                </div>
                <div className=' row p-3 pt-0'>
                    <div className='border p-2 container rounded d-flex gap-2 align-items-center ' style={{ background: '#95d295b0' }}>
                        <h6 className='m-0 p-0 col-8'>Attendence Details</h6>
                        {showAttendance?.attendanceINTime !== ({} && '' && null && undefined) ? <div className='d-flex justify-content-between col-4 pe-2 '>
                            <span > Attendence In Time : <span className='text-primary'> {showAttendance.attendanceINTime}</span></span>
                            <span> Attendence Out Time : <span className='text-primary'> {showAttendance.attendanceOutTime}</span></span>
                        </div> : <></>}
                    </div>

                </div>
                <div className='row'>
                    <div className='col-md-8 mb-3'>      
                        <Calendar
                            views={["month"]}
                            localizer={localizer}
                            defaultDate={new Date()}
                            defaultView="month"
                            style={{ height: "60vh", }}
                            className='my-custom-calendar'
                            eventPropGetter={() => ({ style: { backgroundColor: "transparent",color: 'black', paddingTop: '0px', fontSize: '11px' } })}
                            dayPropGetter={dayPropGetter}
                            tooltipAccessor={tooltipAccessor}
                            components={{
                            }}
                            onNavigate={handleNavigate}
                            events={getEvents()}
                            messages={{
                                next: <span>Next  <i className='fa fa-angle-double-right'></i></span>,
                                previous: <span> <i className='fa 	fa fa-angle-double-left'></i> Previous</span>,
                            }}
                        />                  
                    
                    </div>
                    <div className='col-md-4'>
                        <div className='text-end'>
                            <button className='btn btn-sm btn-info text-white ' onClick={() => navigate('/LeaveManagement/LeaveApplication')}>Apply Leave</button>
                        </div>
                        {/*<Table style={{ display: 'none' }}*/}
                        {/*    headingText='Leave Register'*/}
                        {/*    Filter={false}*/}
                        {/*    Action={false}*/}
                        {/*    Token={TokenData}*/}
                        {/*    PageName=''*/}
                        {/*    showTotalRecord={false}*/}
                        {/*    tableData={tableData}*/}
                        {/*    loading={loading}*/}
                        {/*/>*/}
                        {tableData.Message !== "No Record Found" && (
                            <Table
                                headingText="Leave Register"
                                Filter={false}
                                Action={false}
                                Token={TokenData}
                                PageName=""
                                showTotalRecord={false}
                                tableData={tableData}
                                loading={loading}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmployeeMaster;